import {
  View,
  Text,
  TouchableOpacity,
  Platform,
  Keyboard,
  I18nManager,
} from "react-native";
import React from "react";
import Modal from "react-native-modal";
import MyText from "../custom/MyText";
import { Feather } from "@expo/vector-icons";
import { danger, orange, success } from "../../colors";
import { useDispatch, useSelector } from "react-redux";
import * as Updates from "expo-updates";
import {
  noModal,
  setConfirmLanguageModal,
} from "../../redux/modal/modalAction";
import MyButton from "../custom/MyButton";
import Cookies from "universal-cookie";
import { storeStringData } from "../../functions/db/db";
const cookies = new Cookies();

export default function SelectLanguageModal({ headerText, children }) {
  const dispatch = useDispatch();
  const modal = useSelector((store) => store.modal);
  const setLanguage = (language) => {
    if (Platform.OS === "web") {
      if (language === "En") {
        cookies.set("language", "english");
        location.reload();
      } else {
        cookies.set("language", "persian");
        location.reload();
      }
    }
    if (language === "En") {
      I18nManager.forceRTL(false);
      I18nManager.allowRTL(false);
      storeStringData("languageSet", "english");
      dispatch(noModal());
      Updates.reloadAsync();
    } else {
      I18nManager.forceRTL(true);
      I18nManager.allowRTL(true);
      storeStringData("languageSet", "english");
      dispatch(noModal());
      //   setTimeout(() => dispatch(setConfirmLanguageModal()), 700);
      Updates.reloadAsync();
    }
  };
  return (
    <Modal isVisible={modal.languageModal}>
      <TouchableOpacity
        style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
        activeOpacity={1}
        onPress={() => (Platform.OS !== "web" ? Keyboard.dismiss() : null)}
      >
        <View
          style={{
            width: "94%",
            backgroundColor: "#fefefe",
            padding: 10,
            borderRadius: 10,
            minHeight: 200,
            alignItems: "center",
          }}
        >
          <View
            style={{ flexDirection: "row", width: "100%", marginBottom: 10 }}
          >
            <TouchableOpacity onPress={() => dispatch(noModal())}>
              <Feather name="x" size={24} color={danger} />
            </TouchableOpacity>
            <MyText style={{ marginHorizontal: 10 }}>
              select your language
            </MyText>
          </View>
          <View style={{ width: "90%" }}>
            <MyButton
              onPress={() => setLanguage("En")}
              text="English"
              style={{
                paddingVertical: 10,
                backgroundColor: success,
                marginVertical: 20,
              }}
            />
            <MyButton
              onPress={() => setLanguage("Fa")}
              textStyle={{ fontSize: 17 }}
              style={{ paddingVertical: 10, backgroundColor: orange }}
              text="فارسی"
            />
          </View>
        </View>
      </TouchableOpacity>
    </Modal>
  );
}
